export const environment = {
	production: false,

	api: {
		baseUrl: 'https://devapi.omniscientforge.com',
	},

	storage: {
		accountUrl: 'https://ofblob.blob.core.windows.net',
		container: 'world-assets',
		// TODO: This SAS token expired on 2026-01-07. Please generate a new one via Azure Portal (Storage Account > Shared access signature) or Azure CLI.
		// Ensure permissions: Read, Write, Delete, List, Add, Create, Tags, Filter, Immutable storage.
		sasToken: '?sv=2024-11-04&ss=b&srt=co&sp=rwdlactfx&se=2026-01-07T08:53:08Z&st=2026-01-07T00:38:08Z&spr=https&sig=zirZb0f1HoLKNRNqnDhTrtixq6XoOmq%2BOWXnTl6fC7E%3D',
	},

	auth0: {
		domain: 'dev-e6zhtpr0ejonv6jt.us.auth0.com',
		clientId: 'BfmG9SkxE2jBltA1sVcLNknsO46Ifhde',
		authorizationParams: {
			redirect_uri: window.location.origin,
			audience: 'https://omniscientforge.com',
		},
	},
};